// ─────────────────────────────────────────────────────────────
// Stat card data — edit here to update cards site-wide.
// FORM_PAGE_STATS  → 4 cards above the multi-step form
// LANDING_SP_STATS → 3 cards inside the hero (stats row)
// ─────────────────────────────────────────────────────────────

export const FORM_PAGE_STATS = [
  {
    val:   "1 in 4",
    label: "Businesses file a claim every 3 years",
    sub:   "Industry-wide commercial insurance data",
  },
  {
    val:   "40%",
    label: "Of businesses are underinsured",
    sub:   "Leaving significant gaps in coverage",
  },
  {
    val:   "$1.2M",
    label: "Average cost of a liability lawsuit",
    sub:   "Even with partial coverage in place",
  },
  {
    val:   "68%",
    label: "Of small businesses fail after a major loss",
    sub:   "Without adequate coverage in place",
  },
];

export const LANDING_SP_STATS = [
  { val: "$1.6M+", label: "Total Client Savings" },
  { val: "57%",    label: "Max Premium Reduction" },
  { val: "6",      label: "Industries Served" },
];
